import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'

import getSortedKeys from 'agency/digital_renderer/utils/getSortedKeys'

import SortableSectionWrapper from './SortableSectionWrapper'

const sortComponents = (sortedKeys, components) => {
  if (sortedKeys && sortedKeys.length){
    return sortedKeys.map(key => components.find(c => c.key === key))
  }

  return components
}

const updateDataSourceOptions = (context, name, value) => {
  const {
    callbacks: { updateCampaignProposal, updateDigitalPage },
    dataSource: { id, options: currentOptions },
    dataSourceType,
  } = context

  const updateFn = dataSourceType === 'CampaignProposal' ? updateCampaignProposal : updateDigitalPage

  const updated = {
    id,
    options: JSON.stringify({
      ...currentOptions,
      [name]: value,
    }),
  }

  updateFn(updated)
}

const moveComponent = (context, props, key, direction) => {
  const { components } = props
  const { dataSource } = context

  const sortedKeys = [...getSortedKeys(dataSource, components)]
  const index = sortedKeys.indexOf(key)

  if ((index === 0 && direction === 'up') || (index + 1 === sortedKeys.length && direction === 'down')) return

  const newIndex = direction === 'up' ? index - 1 : index + 1
  sortedKeys.splice(newIndex, 0, sortedKeys.splice(index, 1)[0])

  updateDataSourceOptions(context, 'sorted_section_keys', sortedKeys)
}

const wrapComponents = (components, context, props) => components.map(
  component => component && (
    <SortableSectionWrapper
      key={component.key}
      updateCallback={(key, direction) => moveComponent(context, props, key, direction)}
    >
      {component}
    </SortableSectionWrapper>
  ),
)

const SortableSectionsWrapper = (props) => {
  const { components, render, isSortable } = props
  const defaultContext = useContext(GlobalContext)
  const { dataSource, editing } = defaultContext

  const sortedKeys = getSortedKeys(dataSource, components)
  const sortedComponents = sortComponents(sortedKeys, components)

  if (!components.length) return null

  return render({
    sortedComponents:
      editing && isSortable ? wrapComponents(sortedComponents, defaultContext, props) : sortedComponents,
  })
}

SortableSectionsWrapper.propTypes = {
  components: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
  isSortable: PropTypes.bool,
}

SortableSectionsWrapper.defaultProps = {
  isSortable: true,
}

export default SortableSectionsWrapper
